"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Browsers don't handle bullet/numbering list well, especially the formats when switching list statue
 * So we workaround it by always adding format to list element
 */
function processList(editor, command) {
    var existingList = editor.getElementAtCursor('OL,UL');
    if (roosterjs_editor_dom_1.Browser.isChrome && command !== "indent" /* Indent */) {
        // Chrome has a bug where certain information about elements are deleted when outdent or enter on empty line occurs.
        // We need to clone our current LI node so we can replace the new LI node with it post outdent / enter.
        var parentLINode = editor.getElementAtCursor('LI');
        // We must first be in an LI node to do something to fix this.
        if (parentLINode) {
            // We also don't want to try to handle the multi select outdent case at this time.
            // These are already pretty stable in Chromium.
            var currentRange = editor.getSelectionRange();
            var currentSelectionPath = roosterjs_editor_dom_1.getSelectionPath(parentLINode, currentRange);
            if (currentRange &&
                (currentRange.collapsed ||
                    (editor.getElementAtCursor('LI', currentRange.startContainer) == parentLINode &&
                        editor.getElementAtCursor('LI', currentRange.endContainer) == parentLINode))) {
                // Handle the case for toggling between the two list types as a special case.
                // We'll let the browser handle this for now.
                if ((existingList.tagName === 'OL' &&
                    command === "insertUnorderedList" /* InsertUnorderedList */) ||
                    (existingList.tagName === 'UL' && command === "insertOrderedList" /* InsertOrderedList */)) {
                    editor.getDocument().execCommand(command, false, null);
                }
                else {
                    // Get the next highest list element.
                    // In well formed HTML, this should just be the existing list's parent container.
                    var listParent = existingList.parentElement;
                    if (listParent.tagName == 'OL' || listParent.tagName == 'UL') {
                        if (parentLINode.nextElementSibling) {
                            roosterjs_editor_dom_1.splitBalancedNodeRange(parentLINode);
                        }
                        existingList.insertAdjacentElement('afterend', parentLINode);
                        editor.select(roosterjs_editor_dom_1.createRange(parentLINode, currentSelectionPath.start, currentSelectionPath.end));
                    }
                    else {
                        // In this case, we're going out to the parent root.
                        if (parentLINode.nextElementSibling) {
                            roosterjs_editor_dom_1.splitBalancedNodeRange(parentLINode);
                        }
                        var wrappedContents = roosterjs_editor_dom_1.wrap(roosterjs_editor_dom_1.toArray(parentLINode.childNodes));
                        var wrappedRange = roosterjs_editor_dom_1.createRange(wrappedContents, currentSelectionPath.start, currentSelectionPath.end);
                        var wrappedSelectionPath = roosterjs_editor_dom_1.getSelectionPath(wrappedContents, wrappedRange);
                        existingList.insertAdjacentElement('afterend', wrappedContents);
                        editor.deleteNode(parentLINode);
                        var newRange = roosterjs_editor_dom_1.createRange(wrappedContents, wrappedSelectionPath.start, wrappedSelectionPath.end);
                        editor.select(newRange);
                    }
                    if (existingList.childElementCount == 0) {
                        editor.deleteNode(existingList);
                    }
                }
            }
            else {
                editor.getDocument().execCommand(command, false, null);
            }
        }
        else {
            editor.getDocument().execCommand(command, false, null);
        }
    }
    else {
        editor.getDocument().execCommand(command, false, null);
    }
    var newList = editor.getElementAtCursor('OL,UL');
    if (newList == existingList) {
        newList = null;
    }
    return newList;
}
exports.default = processList;
//# sourceMappingURL=processList.js.map